// extracted by mini-css-extract-plugin
export var container = "_fi-1";
export var cornerButtonContainer = "_fi-6";
export var disabled = "_fi-2";
export var dragActive = "_fi-3";
export var fileContainer = "_fi-5";
export var hiddenInput = "_fi-4";
export var widthContainer = "_fi-0";